export const GET_CREDIT_CARD_BANNER_DATA = 'GET_CREDIT_CARD_BANNER_DATA';
export const SET_CREDIT_CARD_BANNER_DATA = 'SET_CREDIT_CARD_BANNER_DATA';
export const GET_CREDIT_CARD_BANNER_DATA_ERROR = 'GET_CREDIT_CARD_BANNER_DATA_ERROR';
